import { type IDateProps } from './FormattedDate'
import { useFormatDate } from './useFormatDate'

export function useFormatShortDate() {
  const formatDate = useFormatDate()

  return (date: IDateProps['date'] = new Date()) => {
    return formatDate(date, {
      month: 'short',
      day: '2-digit',
      year: 'numeric',
    })
  }
}
